/**
 * assets/custom-footer.js
 * Small progressive-enhancement script for the custom footer newsletter form.
 * No external libraries. Safe to run multiple times / on multiple sections.
 */
(function () {
  'use strict';

  function initNewsletterForms() {
    var forms = document.querySelectorAll('.custom-footer__newsletter-form');

    forms.forEach(function (form) {
      if (form.dataset.footerEnhanced === 'true') return;
      form.dataset.footerEnhanced = 'true';

      form.addEventListener('submit', function () {
        var submitBtn = form.querySelector('.custom-footer__newsletter-submit');
        var emailInput = form.querySelector('input[type="email"]');

        if (emailInput && !emailInput.checkValidity()) {
          return; // let native validation message show
        }

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Subscribing...';
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewsletterForms);
  } else {
    initNewsletterForms();
  }

  // Re-init if the section is re-rendered by the Shopify Theme Editor
  document.addEventListener('shopify:section:load', initNewsletterForms);
})();